/* The section rail, second pass. vc.js shows the rail, lights the dot of the
   section in view and opens the list on a wide screen. This runs after it on
   every scroll and resize and adds three things the settings ask for:

   - the rail is hidden (is-off) below a chosen width, and whenever the free
     margin left of the content is too small for it, so it never sits on the
     text; the list form only opens when there is room for the list too
   - in the closed form the label of the current section is not pinned open;
     the stylesheet shows labels on hover only, and this flashes the current
     label for a moment when the section changes (class "flash")

   All numbers come from the data attributes the section writes. */
(function () {
  'use strict';
  var DOT_LEFT = 14, DOT_W = 40;

  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }

  function bind() {
    var rail = document.querySelector('.vc .vrail[data-vc-vrail]');
    if (!rail || rail.getAttribute('data-vc-rail2')) return;
    rail.setAttribute('data-vc-rail2', '1');

    var minGap = num(rail.getAttribute('data-vc-min-gap'), 16);
    var hideBelow = num(rail.getAttribute('data-vc-hide-below'), 1240);
    var openFrom = num(rail.getAttribute('data-vc-open-from'), 1600);
    var listW = num(rail.getAttribute('data-vc-list-width'), 190);
    var flashMs = num(rail.getAttribute('data-vc-flash'), 0);
    var last = -2, timer = null, ticking = false;

    /* the content shells of the page and their left padding; the text
       starts at the shell's left edge plus that padding */
    var shells = [], pads = [];
    function measure() {
      var list = document.querySelectorAll('#MainContent .vc .shell');
      if (!list.length) list = document.querySelectorAll('#MainContent .shell');
      shells = Array.prototype.slice.call(list);
      pads = shells.map(function (el) { return parseFloat(getComputedStyle(el).paddingLeft) || 0; });
    }

    /* the free margin left of the text: the smallest text edge among the
       shells on screen, else among all of them */
    function gutter() {
      if (!shells.length) return Infinity;
      var onScreen = Infinity, all = Infinity, h = window.innerHeight;
      for (var i = 0; i < shells.length; i++) {
        var r = shells[i].getBoundingClientRect();
        if (!r.width) continue;
        var edge = r.left + pads[i];
        if (edge < all) all = edge;
        if (r.bottom > 0 && r.top < h && edge < onScreen) onScreen = edge;
      }
      return onScreen < Infinity ? onScreen : all;
    }

    function apply() {
      var w = window.innerWidth, g = gutter();
      var off = w < hideBelow || g < DOT_LEFT + DOT_W + minGap;
      rail.classList.toggle('is-off', off);
      var canOpen = w >= openFrom && g >= DOT_LEFT + listW + minGap;
      rail.classList.toggle('is-open', canOpen);

      var links = rail.querySelectorAll('a[data-sec]'), cur = -1;
      for (var i = 0; i < links.length; i++) if (links[i].classList.contains('is-on')) cur = i;
      if (cur !== last) {
        var first = last === -2;
        last = cur;
        if (flashMs > 0 && !canOpen && !off && !first) {
          rail.classList.add('flash');
          clearTimeout(timer);
          timer = setTimeout(function () { rail.classList.remove('flash'); }, flashMs);
        }
      }
    }

    function queue() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { apply(); ticking = false; });
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { measure(); queue(); }, { passive: true });
    measure();
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();